
import {Vue, Component, Prop} from 'vue-property-decorator';
import {userService} from "src/modules/user/UserService";

@Component({})
export default class TeacherIcon extends Vue {
  @Prop({required: false, default: '70px'}) size!: string;
  @Prop({required: false, default: 'default'}) type!: 'selected' | 'premium' | 'default';

  get teacherUrl() {
    return userService.user.configurations.teacherUrl;
  }
}
